export default __webpack_public_path__ + "static/media/1.0c35e126.png";